import { getUserGuidePath } from '@kc-console/context';
import { useTranslation } from '@kc-console/core';

import { GUIDE_PATH } from '../../../constants/guide';
import ExternalLinkButton from './ExternalLinkButton';

/**
 * 프로젝트 역할 가이드 링크 버튼 컴포넌트
 * @description
 * - 현재 리전에 맞는 프로젝트 역할 가이드 문서 URL을 생성합니다.
 * - 생성된 URL로 연결되는 외부 링크 버튼을 렌더링합니다.
 * @example
 * // 권한 안내 페이지에서 사용
 * <ProjectRoleGuideLinkButton />
 */
export default function ProjectRoleGuideLinkButton() {
  const { t } = useTranslation();
  const projectRolesGuideURL = getUserGuidePath(GUIDE_PATH.PROJECT_ROLE_GUIDE_PATH);

  return (
    <ExternalLinkButton
      title={t('layout:service.expection.project_role_guide')}
      url={projectRolesGuideURL}
    />
  );
}
